import {Action} from "@ngrx/store";
import {ACTION, STATUS} from "../constant";

const INIT_STATE = {
  data: null,
  status: null
};

export function PARTICIPATION_FORM_REDUCER(state = INIT_STATE, action: Action) {
  switch (action.type) {

    case ACTION.PARTICIPATION_FORM_APPROVE:
    case ACTION.PARTICIPATION_FORM_DECLINE:
    case ACTION.PARTICIPATION_FORM_EMAIL_SUPPLIER:
    case ACTION.PARTICIPATION_FORM_ENABLE_ORDERING:
    case ACTION.PARTICIPATION_FORM_GENERATE_PROGRAM:
    case ACTION.PARTICIPATION_FORM_INACTIVATE:
    case ACTION.PARTICIPATION_FORM_LOAD:
    case ACTION.PARTICIPATION_FORM_LOAD_CLEANUP:
    case ACTION.PARTICIPATION_FORM_LOAD_DRAFT:
    case ACTION.PARTICIPATION_FORM_AMEND:
    case ACTION.PARTICIPATION_FORM_RETURN:
    case ACTION.PARTICIPATION_FORM_SAVE:
    case ACTION.PARTICIPATION_FORM_SAVE_CLEANUP:
    case ACTION.PARTICIPATION_FORM_SAVE_PROGRAM:
    case ACTION.PARTICIPATION_FORM_RESTRICTED_SITE_APPROVAL:
      return Object.assign({}, state, {data: action.payload, status: STATUS.IN_PROGRESS});
    case ACTION.PARTICIPATION_FORM_INDIVIDUAL_RESTRICTED_SITE_APPROVAL:
      return Object.assign({}, state, {data: action.payload, status: STATUS.IN_PROGRESS});

    case ACTION.PARTICIPATION_FORM_APPROVE_COMPLETED:
    case ACTION.PARTICIPATION_FORM_DECLINE_COMPLETED:
    case ACTION.PARTICIPATION_FORM_EMAIL_SUPPLIER_COMPLETED:
    case ACTION.PARTICIPATION_FORM_ENABLE_ORDERING_COMPLETED:
    case ACTION.PARTICIPATION_FORM_GENERATE_PROGRAM_COMPLETED:
    case ACTION.PARTICIPATION_FORM_INACTIVATE_COMPLETED:
    case ACTION.PARTICIPATION_FORM_LOAD_COMPLETED:
    case ACTION.PARTICIPATION_FORM_LOAD_CLEANUP_COMPLETED:
    case ACTION.PARTICIPATION_FORM_LOAD_DRAFT_COMPLETED:
    case ACTION.PARTICIPATION_FORM_AMEND_COMPLETED:
    case ACTION.PARTICIPATION_FORM_RETURN_COMPLETED:
    case ACTION.PARTICIPATION_FORM_SAVE_COMPLETED:
    case ACTION.PARTICIPATION_FORM_SAVE_CLEANUP_COMPLETED:
    case ACTION.PARTICIPATION_FORM_SAVE_PROGRAM_COMPLETED:
    case ACTION.PARTICIPATION_FORM_RESTRICTED_SITE_APPROVAL_COMPLETED:
      return Object.assign({}, state, {data: action.payload, status: STATUS.COMPLETED});
    case ACTION.PARTICIPATION_FORM_INDIVIDUAL_RESTRICTED_SITE_APPROVAL_COMPLETED:
      return Object.assign({}, state, {data: action.payload, status: STATUS.COMPLETED});

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/reducer/participation-form.reducer.ts